// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { V1VolumeType } from './V1VolumeType';
import {
  V1VolumeTypeFromJSON,
  V1VolumeTypeFromJSONTyped,
  V1VolumeTypeToJSON,
  V1VolumeTypeToJSONTyped,
} from './V1VolumeType';

/**
 *
 * @export
 * @interface V1StorageClassParameters
 */
export interface V1StorageClassParameters {
  /**
   * IOPS of the volume (flat). Must be empty if another IOPS parameter is set.
   * @type {number}
   * @memberof V1StorageClassParameters
   */
  iops?: number;
  /**
   * IOPSPerGB is multiplied by the volume size (GB) to determine volume IOPS. Must be empty if another IOPS parameter is set.
   * @type {number}
   * @memberof V1StorageClassParameters
   */
  iopsPerGB?: number;
  /**
   * IOPSPerVirtualGB is multiplied by the virtual disk size (GB) to determine volume IOPS. Must be empty if another IOPS parameter is set.
   * @type {number}
   * @memberof V1StorageClassParameters
   */
  iopsPerVirtualGB?: number;
  /**
   * Throughput of the volume in MiB/s.
   * @type {number}
   * @memberof V1StorageClassParameters
   */
  throughput?: number;
  /**
   * VolumeType e.g. "gp3", "io-1", "io-2", etc.
   * @type {V1VolumeType}
   * @memberof V1StorageClassParameters
   */
  type?: V1VolumeType;
}

/**
 * Check if a given object implements the V1StorageClassParameters interface.
 */
export function instanceOfV1StorageClassParameters(
  value: object,
): value is V1StorageClassParameters {
  return true;
}

export function V1StorageClassParametersFromJSON(
  json: any,
): V1StorageClassParameters {
  return V1StorageClassParametersFromJSONTyped(json, false);
}

export function V1StorageClassParametersFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1StorageClassParameters {
  if (json == null) {
    return json;
  }
  return {
    iops: json['iops'] == null ? undefined : json['iops'],
    iopsPerGB: json['iopsPerGB'] == null ? undefined : json['iopsPerGB'],
    iopsPerVirtualGB:
      json['iopsPerVirtualGB'] == null ? undefined : json['iopsPerVirtualGB'],
    throughput: json['throughput'] == null ? undefined : json['throughput'],
    type: json['type'] == null ? undefined : V1VolumeTypeFromJSON(json['type']),
  };
}

export function V1StorageClassParametersToJSON(
  json: any,
): V1StorageClassParameters {
  return V1StorageClassParametersToJSONTyped(json, false);
}

export function V1StorageClassParametersToJSONTyped(
  value?: V1StorageClassParameters | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    iops: value['iops'],
    iopsPerGB: value['iopsPerGB'],
    iopsPerVirtualGB: value['iopsPerVirtualGB'],
    throughput: value['throughput'],
    type: V1VolumeTypeToJSON(value['type']),
  };
}
